import './App.css';
import CenterCard from './CenterCard';
import Footer from './Footer.js';

function App() {
  return (
    <>
        <CenterCard />
        <Footer />
    </>
  );
}

export default App;